﻿import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import Head from "@/components/Content/Head";
import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import BasicConfirm from "@/components/Confirm/BasicConfirm";

import ActiveIngredientsTableHead from "./ActiveIngredientsTableHead";
import ActiveIngredientsTableBody from "./ActiveIngredientsTableBody";
import DealersForm from "./ActiveIngredientsForm/ActiveIngredientsForm";
import classes from "../maintainers.module.scss";

import { useActiveIngredientsPaginate, useMutateActiveIngredient, useMutateDeleteActiveIngredient } from "@/hooks/maintainers/active_ingredients";
import { base_list } from "./active_ingredients.constants";

const ActiveIngredients = () => {
	const { addToast } = useToasts();
	const { search } = useSelector((state) => state.auth.filter);
	const { option } = useParams();
	const navigate = useNavigate();

	const [base, setBase] = useState({ ...base_list });
	const [showDelete, setShowDelete] = useState(false);
	const [selected, setSelected] = useState("");

	const { data, isLoading, isFetching } = useActiveIngredientsPaginate({
		...base,
		search,
	});
	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutateActiveIngredient({
		...base,
		search,
	});
	const { mutate: mutateDelete, isLoading: isLoadingDelete } = useMutateDeleteActiveIngredient({
		...base,
		search,
	});

	const { active_ingredients: list } = data ? data : {};
	const { data: active_ingredients, last_page, total, from, to } = list ? list : {};

	const handleDelete = (item) => {
		setSelected(item.id);
		setShowDelete(true);
	};

	const confirmDelete = () => {
		mutateDelete(
			{ ...base, search, selected },
			{
				onSuccess: () => {
					setSelected("");
					setShowDelete(false);
					addToast("Ingrediente Activo eliminado correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const confirmSave = (data) => {
		mutateSave(
			{ ...base, search, params: { ...data } },
			{
				onSuccess: () => {
					addToast("Ingrediente Activo guardado correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const setPage = (value) => setBase({ ...base, page: value });
	const setOrder = (value) => setBase({ ...base, order: value });
	const setOrderType = (value) => setBase({ ...base, orderType: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	if (isLoading || isLoadingDelete) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title="Ingredientes Activos"
				button={true}
				button_text={"Nueva Ingrediente Activo"}
				action={() => navigate("/mantenedores/ingredientes_activos/crear")}
				back_url={"/mantenedores"}
				isFetching={isFetching}
			/>

			<Row className={` ${classes.main_row}`}>
				<Col md={12} className={classes.main_col}>
					<Row className={classes.table}>
						<div className={classes.table_div}>
							<Table className={classes.table_desktop}>
								<ActiveIngredientsTableHead order={base.order} setOrder={setOrder} orderType={base.orderType} setOrderType={setOrderType} />
								<ActiveIngredientsTableBody active_ingredients={active_ingredients} handleDelete={handleDelete} />
							</Table>
						</div>
					</Row>

					<BasePagination
						page={base.page}
						paginate={base.paginate}
						last_page={last_page}
						quantity={total}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			<BasicConfirm
				showConfirm={showDelete}
				setShowConfirm={setShowDelete}
				handleAction={confirmDelete}
				showValidation={true}
				textValidation={"eliminar ingrediente activo"}
			/>

			{option && <DealersForm confirmSave={confirmSave} isLoadingSave={isLoadingSave} />}
		</>
	);
};

export default ActiveIngredients;
